import { useQuery } from '@tanstack/react-query';
import { vaultApi } from '@modules/vault/api';
import { HubException } from '@shared/exceptions';
import useCreateVault from '../mutations/useCreateVault';

const useGetVaultConfig = (oppId: string, isEnabled: boolean = true) => {
  const { mutate: createVault } = useCreateVault(oppId);
  const {
    data, isFetching, isLoading, error, isSuccess, isError,
  } = useQuery({
    queryKey: ['vaultConfig', oppId],
    queryFn: async () => {
      /* eslint-disable @typescript-eslint/return-await */
      try {
        return await vaultApi.getVaultConfig(oppId);
      } catch (_error) {
        if ((_error as HubException).statusCode === 400) {
          await createVault();
          return await vaultApi.getVaultConfig(oppId);
        }
        throw _error;
      }
      /* eslint-enable @typescript-eslint/return-await */
    },
    retry: false,
    enabled: isEnabled,
  });

  return {
    data,
    isFetching,
    isLoading,
    isSuccess,
    error,
    isError,
  };
};

export default useGetVaultConfig;
